import ServiceContainer from 'services/ServiceContainer';
import { ServiceContainerInterface } from 'services/types';

const createServiceContainer = (): ServiceContainerInterface => {
  return new ServiceContainer();
};

export default createServiceContainer();
